export default __webpack_public_path__ + "b4e8d6250b154a49b8ebe177869124b6.png";